import React from 'react'
import { HashRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import { appStore } from './stores/appStore'
import CenterContainer from './containers/CenterContainer'
import Login from './pages/login'
import './App.less'

const App: React.FC = () => {

  let loader = document.getElementById('loader')
  if (loader) {
    loader.remove()
  }

  return (
    <ConfigProvider locale={zhCN}>
      <HashRouter>
        {appStore.myUserData == null ? <Login /> : <CenterContainer />}
      </HashRouter>
    </ConfigProvider>
  )
}

export default App
